import script from "./CustomerInsight.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerInsight.vue?vue&type=script&setup=true&lang=js"

import "./CustomerInsight.vue?vue&type=style&index=0&id=77f86ec9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77f86ec9"]])

export default __exports__